"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crmFieldMappingUpdate = exports.crmFieldMappingSuccess = exports.crmFieldMappingPause = exports.crmFieldMappingList = exports.crmFieldMappingGet = exports.crmFieldMappingError = exports.crmFieldMappingDisconnect = exports.crmFieldMappingDelete = void 0;
var _crmFieldMapping = require("./crmFieldMapping.constant");
// @flow

// common success
var crmFieldMappingSuccess = function crmFieldMappingSuccess(actionType, data) {
  return {
    type: _crmFieldMapping.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.crmFieldMappingSuccess = crmFieldMappingSuccess;
var crmFieldMappingError = function crmFieldMappingError(actionType, error) {
  return {
    type: _crmFieldMapping.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
exports.crmFieldMappingError = crmFieldMappingError;
var crmFieldMappingList = function crmFieldMappingList(data) {
  return {
    type: _crmFieldMapping.actionTypes.LIST,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get of data.
 */
exports.crmFieldMappingList = crmFieldMappingList;
var crmFieldMappingGet = function crmFieldMappingGet(data) {
  return {
    type: _crmFieldMapping.actionTypes.GET,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.crmFieldMappingGet = crmFieldMappingGet;
var crmFieldMappingUpdate = function crmFieldMappingUpdate(data) {
  return {
    type: _crmFieldMapping.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.crmFieldMappingUpdate = crmFieldMappingUpdate;
var crmFieldMappingDelete = function crmFieldMappingDelete(data) {
  return {
    type: _crmFieldMapping.actionTypes.DELETE,
    payload: data
  };
};

/**
 * disconnect
 * @param payload
 * @returns api response
 * @description this function used to disconnect data.
 */
exports.crmFieldMappingDelete = crmFieldMappingDelete;
var crmFieldMappingDisconnect = function crmFieldMappingDisconnect(data) {
  return {
    type: _crmFieldMapping.actionTypes.DISCONNECT,
    payload: data
  };
};

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause data.
 */
exports.crmFieldMappingDisconnect = crmFieldMappingDisconnect;
var crmFieldMappingPause = function crmFieldMappingPause(data) {
  return {
    type: _crmFieldMapping.actionTypes.PAUSE,
    payload: data
  };
};
exports.crmFieldMappingPause = crmFieldMappingPause;